export default "__VITE_ASSET__BWlxOWgr__"